const apiUrls = require('../../constants/apiUrls');

const sqcHistory = {
    key: 'sqcHistory',
    method: 'POST',
    getApiUrl: () => {
        return apiUrls.SQC_RETRIEVE_URL;
    },
    buildPostRequest: (request) => {
        return request;

    },
    dependencies: [
        {
            key: 'orderDetails',
            requestProps: [
                {
                    path: [
                        'details', 'accountNumber'
                    ],
                    propName: 'accountNumber'
                }
            ]
        }
    ]
};

export default sqcHistory;


// WEBPACK FOOTER //
// ./src/store/order-details-config/sqcHistory.js